import { axiosWrapper } from "../../axiosWrapper";

export class CommonService {
  public static async getUserRoles() {
    return await axiosWrapper.Get(`Users/GetUserRoles`);
  }

  public static async populateCountriesDetails() {
    return await axiosWrapper.Get(`CountryProfile/PopulateCountriesDetails`);
  }
}
